import BaseStore from 'customer-flows/stores/base-store'
import { tracked } from '@glimmer/tracking'

export default class CustomerStoreClass extends BaseStore {
  @tracked name?: string
  @tracked email?: string
  @tracked phone?: string
  @tracked optinSms?: boolean
  @tracked optinMarketing?: boolean
}

declare global {
  export type CustomerStore = CustomerStoreClass
  export interface StoreRegistry {
    customer: CustomerStore
  }
}
